export const RESET_CURRENT_USER = 'RESET_CURRENT_USER'
export const BOOTSTRAP_CURRENT_USER = 'BOOTSTRAP_CURRENT_USER'
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER'
